function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{display:inline;fill:#FFFFFF;}\r\n\t.st3{display:inline;fill:none;stroke:#B0BEC5;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,4;}\r\n\t.st4{display:inline;fill:none;stroke:#B0BEC5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st5{display:inline;opacity:0.2;fill:#0F63F2;enable-background:new    ;}\r\n\t.st6{display:inline;fill:#6C63FF;}\r\n\t.st7{display:inline;opacity:0.5;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st8{display:inline;fill:#0F63F2;enable-background:new    ;}\r\n\t.st9{display:inline;fill:#B0BEC5;}\r\n\t.st10{fill:#404547;}\r\n\t.st11{fill:#B0BEC5;}\r\n\t.st12{opacity:0.1;enable-background:new    ;}\r\n\t.st13{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st14{fill:none;stroke:#0F63F2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st15{fill:#0F63F2;}\r\n\t.st16{fill:none;stroke:#B0BEC5;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st17{fill:none;stroke:#B0BEC5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1",
  className: "st0"
}, React.createElement("rect", {
  x: 7.6,
  y: 73.5,
  className: "st1",
  width: 85.7,
  height: 42.4
}), React.createElement("rect", {
  x: 8.5,
  y: 74.4,
  className: "st2",
  width: 83.9,
  height: 40.2
}), React.createElement("line", {
  className: "st3",
  x1: 13,
  y1: 79.8,
  x2: 13,
  y2: 108.8
}), React.createElement("line", {
  className: "st4",
  x1: 12.7,
  y1: 110.8,
  x2: 86.8,
  y2: 110.8
}), React.createElement("line", {
  className: "st4",
  x1: 21.2,
  y1: 81.3,
  x2: 78.8,
  y2: 81.3
}), React.createElement("line", {
  className: "st4",
  x1: 21.2,
  y1: 88,
  x2: 78.8,
  y2: 88
}), React.createElement("line", {
  className: "st4",
  x1: 21.2,
  y1: 94.7,
  x2: 78.8,
  y2: 94.7
}), React.createElement("line", {
  className: "st4",
  x1: 21.2,
  y1: 101.4,
  x2: 78.8,
  y2: 101.4
}), React.createElement("path", {
  className: "st5",
  d: "M25,110.8V94.7c0,0-1.3-6.9,12.3-6.7c12.4-1.8,12.4-6.9,12.4-6.9s11.4-1.2,12,10.9c0.1,2,1.1,3.9,2.7,5.1 c4.7,3.3,8.8-3.3,10.6-9.1v22.8H25z"
}), React.createElement("circle", {
  className: "st6",
  cx: 36.2,
  cy: 87.8,
  r: 1.8
}), React.createElement("circle", {
  className: "st7",
  cx: 36.2,
  cy: 87.8,
  r: 1.8
}), React.createElement("circle", {
  className: "st8",
  cx: 36.2,
  cy: 87.8,
  r: 2.2
}), React.createElement("circle", {
  className: "st6",
  cx: 25,
  cy: 94.9,
  r: 1.8
}), React.createElement("circle", {
  className: "st8",
  cx: 25,
  cy: 94.9,
  r: 1.8
}), React.createElement("circle", {
  className: "st6",
  cx: 49.7,
  cy: 81.5,
  r: 1.8
}), React.createElement("circle", {
  className: "st8",
  cx: 49.7,
  cy: 81.5,
  r: 1.8
}), React.createElement("circle", {
  className: "st6",
  cx: 62.1,
  cy: 94.9,
  r: 1.8
}), React.createElement("circle", {
  className: "st8",
  cx: 62.1,
  cy: 94.9,
  r: 1.8
}), React.createElement("circle", {
  className: "st6",
  cx: 75,
  cy: 88.7,
  r: 1.8
}), React.createElement("circle", {
  className: "st8",
  cx: 75,
  cy: 88.7,
  r: 1.8
}), React.createElement("rect", {
  x: 8,
  y: 121.4,
  className: "st9",
  width: 84.9,
  height: 1.5
}), React.createElement("rect", {
  x: 8,
  y: 125.4,
  className: "st9",
  width: 84.9,
  height: 1.5
}), React.createElement("rect", {
  x: 8,
  y: 129.3,
  className: "st9",
  width: 84.9,
  height: 1.5
}), React.createElement("rect", {
  x: 8,
  y: 133.2,
  className: "st9",
  width: 84.9,
  height: 1.5
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Capa_2"
}, React.createElement("path", {
  d: "M60.2,52.5c-1.3,3.8-3.2,7.2-7.2,7.2s-7-3.2-7.2-7.2c-0.3-5.1,3.1-7.2,7.2-7.2C57.8,45.3,61.7,48,60.2,52.5z"
}), React.createElement("rect", {
  x: 47.8,
  y: 51.6,
  className: "st10",
  width: 11,
  height: 17.2
}), React.createElement("path", {
  className: "st11",
  d: "M51.2,61.5c0,0,0.4,5.4-0.5,6.3s7.8,1.6,7.7,0.6s-1.8-7.6-1.3-8.9S51.2,61.5,51.2,61.5z"
}), React.createElement("path", {
  className: "st12",
  d: "M51.2,61.5c0,0,0.4,5.4-0.5,6.3s7.8,1.6,7.7,0.6s-1.8-7.6-1.3-8.9S51.2,61.5,51.2,61.5z"
}), React.createElement("path", {
  className: "st11",
  d: "M42.8,75.3l-4.5,15.3l-0.2,0.6h-7.6C33.5,81.8,41,68,41,68l1.2-0.3L42.8,75.3z"
}), React.createElement("path", {
  className: "st12",
  d: "M42.8,75.3l-4.5,15.3l-0.2,0.6h-7.6C33.5,81.8,41,68,41,68l1.2-0.3L42.8,75.3z"
}), React.createElement("circle", {
  className: "st11",
  cx: 52.7,
  cy: 57.7,
  r: 5.7
}), React.createElement("path", {
  d: "M58.7,66.7c0,0-2,1.9-4.3,1.5s-3.2-3.1-3.2-3.1L49,66.7c0,0-0.6,4.5,2.3,5s7.1,0.6,7.9,0C60.1,71.1,58.7,66.7,58.7,66.7z"
}), React.createElement("path", {
  className: "st11",
  d: "M65.6,73.4l-0.4,1.2l-5.1,16.6h-22c0-0.2,0.1-0.4,0.1-0.6c0.3-2.4,0.1-8.3,0.1-8.8c0-0.5,2.1-13,2.6-13.9 c0.1-0.1,0.2-0.2,0.3-0.3c0.6-0.3,1.9-0.7,3.3-1c0,0,0,0,0,0c0.8-0.2,1.6-0.4,2.3-0.5h0c0.7-0.1,1.4-0.3,1.9-0.3 c0.3,0,0.5-0.1,0.8-0.1c0.1,0,0.2,0.1,0.3,0.4c0.2,0.7,0.1,2.2,0.1,2.2c0.2,0.2,0.4,0.4,0.6,0.5c0.5,0.4,1,0.7,1.6,0.9 c0.5,0.2,1,0.4,1.5,0.5h0c0.5,0.1,1.1,0.2,1.6,0.3c0.5,0.1,0.9,0,1.4,0h0c1.3-0.2,1.8-1.1,2.1-1.7c0-0.1,0.1-0.2,0.1-0.3 c0,0,0,0,0,0c0.1-0.3,0.1-0.6,0.2-0.5h0c0.2,0,3.1,2.5,5,4.1C64.9,72.8,65.6,73.4,65.6,73.4L65.6,73.4z"
}), React.createElement("path", {
  className: "st12",
  d: "M65.3,74.6l-5.1,16.6h-2.1c0.2-0.3,0.3-0.6,0.2-0.9c-0.1-0.5,1.4-5.2,2.8-9.6c1.3-4,2.5-7.7,2.5-7.7l1.2,0.6 C64.8,73.5,65,73.9,65.3,74.6z"
}), React.createElement("path", {
  className: "st11",
  d: "M68.9,89.7c-0.2,0.1-0.2,0.8-0.2,1.6h-9.8c0.2-0.3,0.4-0.7,0.3-1.1c-0.1-0.4,0.9-5,1.9-9.5 c0.8-3.5,1.5-6.9,1.8-8.1c0.1-0.3,0.1-0.4,0.1-0.4l0.1,0.1l0,0l2.5,1.2l0,0c0,0,3.9,7.4,2.6,9.2c-1.3,1.8-1.3,1.8-0.8,2.6 C68,86.1,69.4,89.5,68.9,89.7z"
}), React.createElement("path", {
  d: "M50.9,50.5c0,0-0.1-0.3-2.4,0.5c-2.3,0.9-3.7,7.3-2.6,11.1c0.5,1.5,0.1,2.6-0.5,3.4c-2.3,2.9-1.4,7.2,2,8.7 c0.1,0,0.2,0.1,0.3,0.1l1.5,0.9c0,0-1.9-2.4-0.9-5.6c0.8-2.7,0.9-5.5,0.3-8.2c-0.1-0.5-0.2-0.9-0.4-1.4c-1.2-4.1-0.6-3.6,3.5-7.7 c0,0,2.3,1.7,4.4,2.6c2,0.9,3.8,1.7,2.3,4.7s-4.9,5.5-2.6,9.3c2.3,3.8,2.6,2.3,2.3,3.8l0,0l-0.3,1.5l1.7-1.7l-1.2,2.3 c0,0,3.8,0,4.9-2.9l0.6,0.6c0,0,2.3-4.1-2-7.9c0,0-1.5-0.9,0.6-3.8s0.5-9.2-2.1-10.3C57.6,49.4,50.9,50.5,50.9,50.5z"
}), React.createElement("line", {
  className: "st13",
  x1: 10.3,
  y1: 77.7,
  x2: 89,
  y2: 77.7
}), React.createElement("line", {
  className: "st14",
  x1: 10.3,
  y1: 77.7,
  x2: 31.4,
  y2: 77.7
}), React.createElement("path", {
  d: "M34.1,81.3v3.2l-5.3-3.2c-0.1-0.1-0.2,0-0.3,0.1c0,0,0,0.1,0,0.1v6.9c0,0.1,0.1,0.2,0.2,0.2c0,0,0.1,0,0.1,0l5.3-3.2v3.2 c0,0.1,0,0.1,0.1,0.1h1.6c0.1,0,0.1,0,0.1-0.1v-7.2c0-0.1,0-0.1-0.1-0.1L34.1,81.3C34.1,81.2,34.1,81.2,34.1,81.3z"
}), React.createElement("path", {
  d: "M20.8,88.5h-1.5c-0.1,0-0.2-0.1-0.2-0.2c0,0,0,0,0,0v-7c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0,0h1.5c0.1,0,0.2,0.1,0.2,0.2 c0,0,0,0,0,0v7C21,88.4,20.9,88.5,20.8,88.5C20.8,88.5,20.8,88.5,20.8,88.5z M24.9,88.5h-1.5c-0.1,0-0.2-0.1-0.2-0.2c0,0,0,0,0,0 v-7c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0,0h1.5c0.1,0,0.2,0.1,0.2,0.2c0,0,0,0,0,0v7C25.1,88.4,25,88.5,24.9,88.5 C24.9,88.5,24.9,88.5,24.9,88.5L24.9,88.5z"
}), React.createElement("path", {
  className: "st15",
  d: "M9.7,81.4v7c0,0.1,0.1,0.2,0.2,0.2c0,0,0.1,0,0.1,0l5.5-3.5c0.1-0.1,0.1-0.2,0.1-0.3c0,0,0,0-0.1-0.1L10,81.2 c-0.1-0.1-0.2,0-0.2,0.1C9.7,81.3,9.7,81.3,9.7,81.4z"
}), React.createElement("line", {
  className: "st16",
  x1: 6.9,
  y1: 94.8,
  x2: 85.6,
  y2: 94.8
}), React.createElement("line", {
  className: "st16",
  x1: 6.9,
  y1: 99,
  x2: 21.4,
  y2: 99
}), React.createElement("rect", {
  x: 6.6,
  y: 42.1,
  className: "st17",
  width: 86.5,
  height: 49.2
}), React.createElement("circle", {
  cx: 53,
  cy: 44,
  r: 2.9
}), React.createElement("path", {
  d: "M49.5,42.5c0-1.5,1.1-2.7,2.6-2.8c-0.1,0-0.2,0-0.3,0c-1.6,0-2.9,1.3-2.9,2.9c0,1.6,1.3,2.9,2.9,2.9c0.1,0,0.2,0,0.3,0 C50.7,45.1,49.5,43.9,49.5,42.5z"
}));

var SvgPreview = function SvgPreview(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 150",
    style: {
      enableBackground: "new 0 0 100 150"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPreview, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/preview.06ea7566.svg";
export { ForwardRef as ReactComponent };